export const coordinationEndpoints = {
  approveAction: '/coordination/actions/{coordinationActionId}/approve',
  rejectAction: '/coordination/actions/{coordinationActionId}/reject',
  meetingById: '/coordination/meetings/{meetingId}',
  meetingCandidateMetadata:
    '/coordination/meetings/{meetingId}/candidate-metadata',
  preconditions: '/jobs/{jobId}/coordination-preconditions',
  processes: '/jobs/{jobId}/coordination-processes',
  processDetail: '/jobs/{jobId}/coordination-processes/{coordinationProcessId}',
  processStatus:
    '/jobs/{jobId}/coordination-processes/{coordinationProcessId}/status',
} as const;
